import jQuery from 'jquery';
import 'jquery-ui';
import 'jquery-validation';
import "./railsujs_shared";

if (!window.jQuery) {
  window.$ = window.jQuery = jQuery;
}
